var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "icon-poster"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon-style"
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "miter",
    fill: "white",
    points: "32,14 49,45 15,45 32,13 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282D37",
    fillRule: "nonzero",
    d: "M32 11.984c-1.49 0-2.859.82-3.56 2.134L13.493 42.076a4.037 4.037 0 0 0 3.56 5.94h29.891a4.037 4.037 0 0 0 3.56-5.94L35.56 14.118A4.037 4.037 0 0 0 32 11.984zm0 2c.751 0 1.442.414 1.796 1.077l14.946 27.958a2.037 2.037 0 0 1-1.797 2.997h-29.89a2.037 2.037 0 0 1-1.797-2.997l14.945-27.958A2.037 2.037 0 0 1 32 13.984z",
    className: "base"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC0016",
    d: "M32 39.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM32 22a1 1 0 0 1 .993.883L33 23v13a1 1 0 0 1-1.994.117L31 36V23a1 1 0 0 1 1-1z",
    className: "pulse"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.25d4d11835c95fc686e37b9f1097575e.svg";
export { ForwardRef as ReactComponent };